# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.controllers').controller 'FormsCtrl', [
  '$scope', '$rootScope', 'APIForm', 'UI'
].append (self, root, APIForm, UI) ->

  params = new URLSearchParams(window.location.search)

  if params.get('error') == 'invalid_token'
    UI.notify false, 'Ein Fehler ist aufgetreten. Der Token ist ungültig.' 
  if params.get('error') == 'already_set'
    if params.get('status') == 'approved'
      UI.notify false, 'Die Akkreditierung wurde bereits bestätigt.' 
    else if params.get('status') == 'rejected'
      UI.notify false, 'Die Akkreditierung wurde bereits abgelehnt.' 

  if params.get('success') == 'true'
    if params.get('status') == 'approved'
      UI.notify true, 'Die Akkreditierung wurde erfolgreich bestätigt.' 
    else if params.get('status') == 'rejected'
      UI.notify true, 'Die Akkreditierung wurde abgelehnt.' 

  self.formProccess = false

  self.resetData = (subject = '', form = '') ->
    self.data =
      subject: subject
      form: form
      gender: ''
      titel: ''
      first_name: ''
      last_name: ''
      email: ''
      phone: ''
      company: ''
      theme: ''
      note: ''
      functions: ''
      redaction: ''
      medium: ''
      eventname: ''
      address: ''
      housenumber: ''
      address_additional: ''
      zip: ''
      city: ''
      country: ''
      website: ''
      check_1: false

  self.saveForm = (form, name, subject) ->
    self[name] = form
    self.resetData(subject, name)

  self.sendForm = () ->
    self.formProccess = true

    (new APIForm self.data).$save {}, (data) ->
      self.formProccess = false


      element = angular.element(document.getElementById(self.data.form))
      element[0].scrollIntoView()

      UI.notify true, data.message

      self[self.data.form].$setPristine()
      self[self.data.form].$setUntouched()

      self.resetData(self.data.subject, self.data.form)

    , (response) ->

      self.formProccess = false
      UI.notify false, response.data.error
